import { Component, Input, OnInit } from '@angular/core';
import { ScrudgRevisionService } from '../../../services/base/scrudg-revision/scrudg-revision.service';
import { AppService } from '../../../services/app.service';
import { ItemEnvelope } from '../../../models/net/envelope/base/item-envelope';
import { RevisionSearchRequest } from '../../../models/net/request/revision-search-request';
import { RevisionSearchResult } from '../../../models/net/result/revision-search-result';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.css']
})

export class HistoryComponent implements OnInit {

    public revisions: RevisionSearchResult[] = [];

    @Input() public itemEnvelope: ItemEnvelope | undefined = undefined;
    @Input() public itemService: ScrudgRevisionService | undefined;

    public constructor(public appService: AppService) { }

    public ngOnInit(): void { }

    public searchRevisions = (): void => {

        const itemId: number = this.itemEnvelope!.ItemId;
        const request: RevisionSearchRequest = new RevisionSearchRequest();

        request.ItemId = itemId;

        this.itemService!.searchRevisions(request).subscribe((r: RevisionSearchResult[] | null) => {

            if (r != null) {

                this.revisions = r;
            }
        });
    }

    public showRevision = (revisionSearchResult: RevisionSearchResult): void => {

        const itemTypeName: string = this.itemEnvelope!.ItemTypeName.toLowerCase();
        const itemId: number = this.itemEnvelope!.ItemId;
        const revisionOrdinal: number = revisionSearchResult.RevisionOrdinal;

        this.appService.navigateTo(itemTypeName + "/" + itemId.toString() + "/revision/" + revisionOrdinal.toString(), "");
    }
}
